<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        故障维修台账
      </h2>
      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
        <k-button
          btn-text="新增"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="handleDialog('add', {dlType: 'add',xmId: xmId})"
        />
        <import-upload
          ref="fduploadgzwx"
          accept="xlsx,xls"
          :action="`${importUrl}`"
          success-alert-msg="导入成功"
          class="u-inline-block u-mg-l-8"
        />
        <k-button
          btn-text="导入"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-import"
          plain
          @click="handlePreview"
        />
        <k-button
          btn-text="模板下载"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-cloud-download"
          plain
          @click="handleDownload()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="排除确认"
                prop="gzpcqr"
              >
                <el-select
                  v-model="filterParams.gzpcqr"
                  class="c-form__select"
                  placeholder="请选择状态"
                  clearable
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="(item,index) in gzpcqrType"
                    :key="index"
                    :label="item.text"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #qkms="scope"
            >
              <el-link
                type="primary"
                @click="handleDialog('edit', {dlType: 'edit', id: scope.row.uuid})"
              >
                {{ scope.row.qkms }}
              </el-link>
            </template>

            <template
              #gzpcqr="scope"
            >
              {{ getQkms(scope.row.gzpcqr) }}
            </template>

            <el-table-column
              prop="enabled"
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template
                slot-scope="scope"
              >
                <k-button
                  v-if="scope.row.tsbz === 'N'"
                  btn-text="编辑"
                  :auth-type="true"
                  type="primary"
                  plain
                  @click="handleDialog('edit', {dlType: 'edit', id: scope.row.uuid})"
                />
                <k-button
                  v-if="scope.row.tsbz === 'N'"
                  btn-text="删除"
                  :auth-type="true"
                  type="danger"
                  @click="handleDel(scope.row, scope.$index)"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>

      <div class="o-tips">
        已出过报告的维保计划不可修改和删除台账
      </div>
    </div>
    <!-- 页面主内容：查询列表 End -->

    <!-- 新增/修改维保计划信息 -->
    <gzwx-dialog
      v-if="showDialogName==='add' || showDialogName==='edit'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />
  </div>
</template>
<script>
import gzwxDialog from './gzwxDialog.vue';
import { gzwxService } from '@/features/xfwbgl/gzwx/gzwx.service';
export default {
  name: 'GzwxList',
  components: {
    gzwxDialog
  },
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      xmId: null, // 项目id
      gzpcqrType: [
        { id: '1', text: '执行中' },
        { id: '2', text: '已维修' }
      ],
      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        uuid: null,
        xmId: null, // 项目id
        qkms: null,
        gzpcqr: null
      },
      /* 查询条件 end */
      importUrl: '',
      upLoadText: null,
      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */
      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'qkms', slotName: 'qkms', label: '故障情况描述', align: 'left', type: 'text' },
        { key: 'gzfxsj', label: '发现时间', align: 'center', width: '140', type: 'date' },
        { key: 'gzfxr', label: '发现人', align: 'center', width: '140', type: 'text' },
        { key: 'wxsj', label: '维修时间', align: 'center', width: '140', type: 'date' },
        { key: 'wxry', label: '维修人员', align: 'center', width: '140', type: 'text' },
        { key: 'wxff', label: '维修方法', align: 'left', width: '300', type: 'text' },
        { key: 'gzpcqr', slotName: 'gzpcqr', label: '排除确认', align: 'center', width: '100', type: 'text' }
      ],
      /* 表格列配置End */

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */
    };
  },
  methods: {
    getQkms (gzpcqr) {
      if (gzpcqr === '1') {
        return '执行中';
      } else if (gzpcqr === '2') {
        return '已维修';
      }
      return '未知';
    },
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },

    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      gzwxService.query(this.trueFilterParams)
        .then(rsp => {
          console.log('查询故障台账列表成功！', rsp.data);
          this.page = Object.assign({}, this.page, rsp.data);
          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      if (_row.tsbz === 'Y') {
        this.$alert('已出过报告的维保计划不可删除台账！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        });
        return;
      }

      const _this = this;
      _this.$confirm('是否确认删除此故障台账明细？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        gzwxService.delete(_row.uuid)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.refreshSearch();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 点击下载模板
     * @param {*}
     * @return {*}
     */
    handleDownload () {
      this.loading = true;
      gzwxService.exportGzwxFile()
        .then((rsp) => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('故障维修模板下载出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 触发上传按钮
     * @return {*}
     */
    submitUpload () {
      this.upLoadText = {
        creator: window.sessionStorage.getItem('accountName'),
        fileName: this.fileName,
        requirement: this.selectedRequirement
      };
      console.log(this.$refs.fduploadgzwx);
      this.$refs.fduploadgzwx.handleClick();
      this.loading = false;
    },
    /**
     * @description: 文件上传前处理
     * @return {*}
     */
    handlePreview () {
      const _this = this;
      const h = this.$createElement;
      this.$confirm('提示', {
        title: '提示',
        message: h('div', [h('p', '1、请使用模板导入设备信息，表中数据均为必填信息。'), h('p', '2、为保证成功，请根据表中数据格式及字段顺序依次填写。')]),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          _this.loading = true;
          _this.submitUpload();
        }).catch(() => {
        });
      _this.loading = false;
    }
  },
  created () {
    this.xmId = this.$route.params.xmId;
    this.filterParams.xmId = this.xmId;
    this.importUrl = this.$config.ctx.iffApi + `/xfwb/gzwx/${this.xmId}/import`;
    console.log('created this.$route.params', this.$route.params);
    this.refreshSearch();
  },
  activated () {
    this.xmId = this.$route.params.xmId;
    this.filterParams.xmId = this.xmId;
    this.importUrl = this.$config.ctx.iffApi + `/xfwb/gzwx/${this.xmId}/import`;
    console.log('activated this.$route.params', this.$route.params);
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }

};
</script>
<style lang="scss" scoped>
.dev-c-wbjh--header_button{
  margin-bottom: 10px;
}

.o-tips {
  position: absolute;
  top: 4px;
  right: 12px;
  z-index: 9;
  padding-left: 8px;
  border-left: 0;
  color: #f56c6c;
  background-color: #fef0f0;
}
</style>
